/*
Purpose: list details of report with use datatable
Developer: BY KTH
Date:22/08/2023 
Project: TCMS
*/

import { useState, useEffect } from "react";
import { NavLink } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Card from "react-bootstrap/Card";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Typography from "@mui/material/Typography";
import Moment from "moment";
import axios from "axios";
import Box from "@mui/material/Box";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import LinearProgress from "@mui/material/LinearProgress";
import Button from "@mui/material/Button";
import Form from "react-bootstrap/Form";
import {
    security_key,
    BASE_URL,
} from "../global";
import { timesheetInMonth, timesheetMonthOptions } from "../components/TimesheetPrint";
import PrintTimesheetModal from "../components/PrintTimesheetModal";
function DailyPGPayments() {
    const [loading, setLoading] = useState(true);
    
    const [data, setItems] = useState([]);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        try {
            const response = await axios.post(BASE_URL + "API/api_index.php", {
                security_key: security_key,
                mode: "getTutorTimesheetReportCenter",
                fk_cent_key: sessionStorage.getItem("key"),
            });
            
            if (response.data.success === true) {
                setRecords(response.data.data);
                setItems(response.data.data);
                setLoading(false);
            } else {
                //alert message provide
                setLoading(false);
            }
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };

    //Api call End

    

    const columns = [

        {
            headerName: 'From Date',
            field: 'timesheet_from_date',
            headerClassName: 'super-app-theme--header',
            minWidth: 100,
            flex: 1,
            valueGetter: (params) => {
            const from = params?.row?.timesheet_from_date;
            if (!from) return '-';
            return Moment(from).format('DD-MM-YYYY');
            },
        },
        {
            headerName: 'To Date',
            field: 'timesheet_to_date',
            headerClassName: 'super-app-theme--header',
            minWidth: 100,
            flex: 1,
            valueGetter: (params) => {
            const to = params?.row?.timesheet_to_date;
            if (!to) return '-';
            return Moment(to).format('DD-MM-YYYY');
            },
        },
        {
          headerName: 'Tutor Name',
          field: "tutor_name",
          headerClassName: "super-app-theme--header",
          flex: 1,
          valueGetter: (params) => {
                return `${params.row.tut_fname && params.row.tut_fname != '' ? params.row.tut_fname+" "+params.row.tut_surname : '-'}`;
            },
        },
        {
            headerName: "Phone",
            field: "tut_home_phone",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
                return `${params?.row?.tut_home_phone ? params.row.tut_home_phone : '-'}`;
            },
        },
        {
            headerName: 'Pay Type Applied',
            field: "timesheet_pay_type",
            headerClassName: "super-app-theme--header",
            minWidth: 120,
            flex: 1,
            valueGetter: (params) =>
                params?.row?.timesheet_pay_type == '1' ? "Flat Rate" :
                params?.row?.timesheet_pay_type == '2' ? "Per Session Rate" :
                params?.row?.timesheet_pay_type == '3' ? "Per Student Rate" :
                params?.row?.timesheet_pay_type == '4' ? "Banded Student Rate" : '-',
        },
        {
            headerName: "Amount(" + (+sessionStorage.getItem('currency_code') != null && sessionStorage.getItem('currency_code') != '' ? sessionStorage.getItem('currency_code') : 'SGD') + ")",
            field: "amount",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
              return `${params.row.timesheet_total_amount && params.row.timesheet_total_amount != '' ?  Number(params.row.timesheet_total_amount).toFixed(2) : '-'}`;
            },
          },
          {
            headerName: 'Frequency (Weekly/Monthly)',
            field: "timesheet_frequency",
            headerClassName: "super-app-theme--header",
            flex: 1,
            valueGetter: (params) => {
              return `${params?.row?.timesheet_frequency || '-' }`;
            },
          }, 
        {
          headerName: 'Status (Paid/Pending)',
          field: "timesheet_paid_status",
          headerClassName: "super-app-theme--header",
          flex: 1,
          valueGetter: (params) => {
            return `${params?.row?.timesheet_paid_status == 1 ? 'Paid' : 'Pending'}`;
          },
          renderCell: (params) => {
            const row = params.row;
            if (params?.row?.timesheet_paid_status == 1) {
                // Replace this condition with your actual condition
                return <p className="badge cus-badge-Success mb-0">Paid</p>;
                
            } else {
                return <p className="badge cus-badge-danger mb-0">Pending</p>;
            }
            
          }
    
        }
    
    
      ];

    const [records, setRecords] = useState(data);

    // '' = all months. A timesheet is in a month when its period overlaps it, so a week spanning
    // two months is listed under both. The Print PDF pop-up opens on all tutors and this month.
    const [selectedMonth, setSelectedMonth] = useState("");
    const [showPrintModal, setShowPrintModal] = useState(false);
    const monthOptions = timesheetMonthOptions(records);
    const visibleRecords = records.filter((ts) => timesheetInMonth(ts, selectedMonth));


    return (
        <div className="">
            {/* --------------Page Start--------------- */}

            <div className="mb-3 d-flex justify-content-between align-items-center">
                <div>
                    <h5 className="page-title">Timesheet Reports </h5>

                    <div role="presentation">
                        <Breadcrumbs aria-label="breadcrumb" className="my-breadcrumbs">
                            <NavLink underline="hover" color="inherit" to="/calendar">
                                {" "}
                                Home
                            </NavLink>
                            <NavLink underline="hover" color="inherit" to="/reports">
                                {" "}
                                Reports
                            </NavLink>
                            <Typography color="text.primary">Timesheet Reports </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div className="d-flex align-items-center gap-2">
                    {/* <Button onClick={() => navigate('/reports')} className="secondary-filled" variant="contained">
            Back
          </Button> */}
                </div>
            </div>
            {/* --------------Section Start--------------- */}

            <Card className="card my-card mb-3">
                <Card.Body>
                    {/* -------------Content Start--------------- */}

                    <Row>
                        <Col xs="12">
                            <div className="">
                                <Row className="justify-content-center">
                                    {/* --------------Table Content Start--------------- */}
                                    <Col sm={12}>
                                        <div className="d-flex flex-wrap justify-content-end align-items-center gap-2 mb-3">
                                            <Form.Select
                                                size="sm"
                                                style={{ width: "170px" }}
                                                value={selectedMonth}
                                                onChange={(e) => setSelectedMonth(e.target.value)}
                                                aria-label="Filter by month"
                                            >
                                                <option value="">All months</option>
                                                {monthOptions.map((m) => (
                                                    <option key={m.value} value={m.value}>{m.label}</option>
                                                ))}
                                            </Form.Select>
                                            <Button
                                                variant="contained"
                                                className="primary-filled"
                                                onClick={() => setShowPrintModal(true)}
                                            >
                                                Print PDF
                                            </Button>
                                            <PrintTimesheetModal
                                                show={showPrintModal}
                                                onHide={() => setShowPrintModal(false)}
                                                defaultMonth={selectedMonth}
                                            />
                                            {/* <CSVLink
                                                data={csvData}
                                                filename={csvFileName}
                                                // className="btn btn-primary"
                                                target="_blank"
                                            >
                                                <i class="fa-solid fa-file-csv my-auto" style={{ fontSize: "24px" }}></i>
                                            </CSVLink>

                                            <div class="form-group has-search my-auto">
                                                <span class="fa fa-search form-control-feedback"></span>
                                                <input type="text" class="form-control mb-0" onChange={handleFilter} />
                                            </div> */}
                                        </div>
                                    </Col>
                                    {/* --------------Table Content Start--------------- */}

                                    {/* --------------Table Content Start--------------- */}
                                    <Col sm={12}>
                                        {/* <DataTable
                                            progressPending={loading}
                                            columns={columns}
                                            data={records}
                                            fixedHeader
                                            pagination
                                            customStyles={customeStyle}
                                            className="cursor-pointer  list-cus-h"
                                        /> */}

                                    <Box
                                        sx={{
                                        height: "fit-content",
                                        width: "100%",
                                        "& .actions": {
                                            color: "text.secondary",
                                        },
                                        "& .textPrimary": {
                                            color: "text.primary",
                                        },
                                        "& .super-app-theme--header": {
                                            backgroundColor: "#e3e6ee",
                                        },
                                        }}
                                        style={{ height: '100%', width: "100%" }}
                                    >
                                    <DataGrid
                                                sx={{
                                                // disable cell selection style
                                                '.MuiDataGrid-cell:focus': {
                                                    outline: 'none'
                                                },
                                                // pointer cursor on ALL rows
                                                '& .MuiDataGrid-row:hover': {
                                                    cursor: 'pointer'
                                                }
                                                }}
                                        //sx={{ border: "none", m: 2 }}
                                        autoHeight
                                        slots={{
                                            loadingOverlay: LinearProgress,
                                            //noRowsOverlay: CustomNoRowsOverlay,
                                            toolbar: GridToolbar,
                                            // toolbar: EditToolbar,
                                        }}
                                        slotProps={{
                                            toolbar: {
                                            csvOptions: { fileName: "TimesheetList" },
                                            printOptions: { pageStyle: `@media print {
                                                    @page {
                                                        size: A4 landscape;
                                                        margin: 0;
                                                    }
                                                    }`, disableToolbarButton: true, hideFooter: true, hideToolbar: true, fileName: "TimesheetList" },
                                                    records,
                                            showQuickFilter: true
                                            },


                                        }}
                                        initialState={{
                                            ...records.initialState,
                                            pagination: { paginationModel: { pageSize: 10 } },
                                        }}
                                        showQuickFilter={true}

                                        pageSizeOptions={[10, 25, 50, 100]}

                                        loading={loading}
                                        rows={visibleRecords.map((row, index) => ({ ...row, id: `${index+1}` }))}
                                        columns={columns}
                                        rowHeight={60} density="compact"
                                        disableRowSelectionOnClick
                                        showCellVerticalBorder= {true}
                                        showColumnVerticalBorder= {true}

                                        />


                                    </Box>
                                    </Col>
                                    {/* --------------Table Content Start--------------- */}
                                </Row>
                            </div>
                        </Col>
                    </Row>

                    {/* --------------Content End--------------- */}
                </Card.Body>
            </Card>

            {/* --------------Section End--------------- */}

            {/* --------------Page End--------------- */}
        </div>
    );
}

export default DailyPGPayments;
